import React from "react";
import PropTypes from "prop-types";
import { Box, Divider, Stack, Typography } from "@material-ui/core";

/**
 * Wrapper visual de un bloque del PanelAdmin de VerPropuestaV2.
 * Título en caption bold con ícono opcional + divider + body.
 *
 * Los bloques viven dentro de un Paper común (el Paper lo maneja PanelAdmin).
 * Usar este componente asegura consistencia visual (títulos, espaciado) entre
 * los distintos bloques (metadata, solicitante, acciones, notas, historial).
 */
const BloquePanelAdmin = ({ titulo, icono, children, dense }) => (
  <Box>
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
      {icono}
      <Typography
        variant="overline"
        color="textSecondary"
        sx={{ fontWeight: 700, letterSpacing: 0.5 }}
      >
        {titulo}
      </Typography>
    </Stack>
    <Divider sx={{ mb: dense ? 1 : 1.5 }} />
    <Box>{children}</Box>
  </Box>
);

BloquePanelAdmin.propTypes = {
  titulo: PropTypes.string.isRequired,
  icono: PropTypes.node,
  children: PropTypes.node.isRequired,
  dense: PropTypes.bool,
};

BloquePanelAdmin.defaultProps = {
  icono: null,
  dense: false,
};

export default BloquePanelAdmin;
